import { Application } from "stimulus"
import ManageFiltersController from "../../controllers/manage_filters_controller"

export default class RowFiltersController extends ManageFiltersController {

  filterMap = {};
  filterIds = [];
  filtersSelectedCount = 0;
  specialSectionMapping = [ "pro", "features" ]

  static values = { filterParams: Object, translates: Object }

  static targets = [
    "labelContainer", "filtersCounter", "filtersText", "filter", "resetAllFilters"
  ]
  
  connect() {
    this.initializeFilters();
    this.initializeActions();
    if (this.filtersSelectedCount > 0) {
      this.filtersGlobalCounter();
      this.filtersGlobalReset();
    }
  }

  initializeFilters() {
    this.setFilterObjects();
    this.setFilters();
  }

  initializeActions() {
    this.allFiltersBottomSheet = document.querySelector("[data-type='bottom-sheet-filters']");
    this.sheetContent = this.allFiltersBottomSheet.querySelector("[data-modal-bottom-sheet-target='sheetContent']");
    this.closeBottomSheet = this.allFiltersBottomSheet.querySelector("[data-modal-bottom-sheet-target='close']");
    this.closeScrimBottomSheet = this.allFiltersBottomSheet.querySelector(".bottom-sheet-draggable-thumb");
    this.resetActionBottomSheet = this.allFiltersBottomSheet.querySelector("[data-type='reset-action']");
    this.checksBottomSheet = this.allFiltersBottomSheet.querySelectorAll(".checks-container input");
    this.submitBottomSheet = this.allFiltersBottomSheet.querySelector("[data-modal-bottom-sheet-target='bottomActions'] .place-date-submit");
    this.initializeActionHandlers();
  }

  initializeActionHandlers() {
    this.closeBottomSheet.addEventListener("click", () => this.closeBottomSheetHandler());
    this.closeScrimBottomSheet.addEventListener("click", () => this.closeBottomSheetHandler());
    this.resetActionBottomSheet.addEventListener("click", () => this.resetActionBottomSheetHandler());
    this.checksBottomSheet.forEach((checkContainer) => {
      checkContainer.addEventListener("click", (e) => this.displayActionFilters());
    });
  }

  closeBottomSheetHandler() {
    this.allFiltersBottomSheet.querySelectorAll(".checks-container").forEach((container) => {
      container.querySelectorAll(`input[type=checkbox]`).forEach((input) => {
        var filterId = container.dataset.filterId;
        input.checked = false
        if (this.checkFiltercondition(filterId, input)) {
          input.checked = true
        }
      });
    });
  }

  displayActionFilters() {
    var filtersChecked = this.allFiltersBottomSheet.querySelectorAll(".checks-container:not(.d-none) input[type=checkbox]:checked")
    if(filtersChecked.length > 0) {
      this.resetActionBottomSheet.classList.remove("d-none");
      this.submitBottomSheet.innerText = this.translatesValue.apply;
    }else {
      this.resetActionBottomSheet.classList.add("d-none");
      this.submitBottomSheet.innerText = this.translatesValue.show_all;
    }
  }

  resetActionBottomSheetHandler() {
    this.allFiltersBottomSheet.querySelectorAll(".checks-container:not(.d-none) input[type=checkbox]").forEach(el => el.checked = false);
    this.displayActionFilters();
  }

  setFilterObjects() {
    this.filterTargets.forEach((f) => { 
      this.filterIds.push(f.id);
      this.filterMap[f.id] = f;
    });
  }

  setFilters() {
    this.filterIds.forEach((id) => {
      const categoryShowValue = document.querySelector(`#check-container-${id} input:checked`)
      const paramId = this.specialSectionMapping.includes(id) && categoryShowValue ? categoryShowValue.id : id;
      var filterParam = paramId.includes("category-group") ? this.filterParamsValue["category_places"] : this.filterParamsValue[paramId];
      if(filterParam != undefined && categoryShowValue) {
        var filter = this.filterMap[id];
        filter.classList.add("chip-item-selected");
        filter.querySelector(".action-icon-fa-times").classList.remove("d-none")
        filter.querySelector(".action-icon-chevron-down").classList.add("d-none")
        var filterText = filter.querySelector("span");
        this.setFilterLabel(id, filterParam, filterText)
      }
    })
  }

  setFilterLabel(filterKey, filterParam, filterText) {
    const categoryShowValue = document.querySelectorAll(`#check-container-${filterKey} input:checked`);
    const firstCategoryShowValue = categoryShowValue[0].closest('label').querySelector("span").textContent.replace(/\n/g, '');
    if (categoryShowValue.length == 1) {
      filterText.innerText = firstCategoryShowValue;
      this.filtersSelectedCount++;
    } else {
      filterText.innerText = `${firstCategoryShowValue} ${this.translatesValue.and_n_more.replace('%{count}', categoryShowValue.length - 1)}`;
      this.filtersSelectedCount+=categoryShowValue.length;
    }
  }

  showFilter(e) {
    var id = e.target.closest(".chip-item").id;
    if(id != "allFilters") {
      this.displayFilter(id);
    }else {
      this.displayAllFilters();
    }
    this.displayActionFilters();
  }

  checkFiltercondition(filterId, input) {
    const paramId = this.specialSectionMapping.includes(filterId) ? input.id : filterId;
    const filterCondition = this.filterParamsValue[paramId] && (this.filterParamsValue[paramId] == "true" || this.filterParamsValue[paramId].indexOf(input.value) != -1);
    const categoryFilterCondition = this.filterParamsValue["category_places"] && this.filterParamsValue["category_places"].indexOf(input.value) != -1;
    return filterCondition || categoryFilterCondition;
  }

  displayFilter(filterId) {
    this.sheetContent.style.paddingBottom = "10rem";
    this.allFiltersBottomSheet.querySelectorAll(".checks-container").forEach((container) => {
      container.classList.add("d-none");
      var containerTitle = container.querySelector(".check-container-title-label");
      containerTitle.classList.remove("d-none");
      if (container.id == `check-container-${filterId}`) {
        container.classList.remove("d-none");
        containerTitle.classList.add("d-none");
        this.allFiltersBottomSheet.querySelector("[data-type='bottom-sheet-title']").textContent = containerTitle.textContent;
      }
    })
  }

  displayAllFilters() {
    this.sheetContent.style.paddingBottom = "20rem";
    this.allFiltersBottomSheet.querySelector("[data-type='bottom-sheet-title']").textContent = this.labelContainerTarget.querySelector(".filters-text").textContent;
    this.allFiltersBottomSheet.querySelectorAll(".checks-container").forEach((container) => {
      container.classList.remove("d-none");
      var containerTitle = container.querySelector(".check-container-title-label");
      containerTitle.classList.remove("d-none");
    })
  }

  filtersGlobalCounter() {
    this.labelContainerTarget.classList.add("enable");
    this.filtersCounterTarget.innerText = this.filtersSelectedCount;
  }

  filtersGlobalReset(){
    this.resetAllFiltersTarget.classList.remove("d-none")
  }

  clearFilter(event) {
    event.stopPropagation();
    var id = event.target.closest(".chip-item").id;
    document.getElementById(`check-container-${id}`).querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
    if (window.bottomSheet != null) {
      window.desactivateBottomSheet()
    }
    this.filter(event);
  }

  clearAllFilters(event){
    this.allFiltersBottomSheet.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
    this.filter(event);
  }

  showLeftShadow(event){
    if (event.target.scrollLeft > 0) {
      this.labelContainerTarget.classList.add("label-container-shadow")
      this.filtersTextTarget.classList.add("d-none")
    }else {
      this.labelContainerTarget.classList.remove("label-container-shadow")
      this.filtersTextTarget.classList.remove("d-none")
    }
  }

}

const application = Application.start()
application.register("row-filters", RowFiltersController)
